import React from "react";
import Input from "../../../../Components/Common/Input";
import Selector from "../../../../Components/Common/Selector";
import HtmlEditor from "../../../../Components/Common/HtmlEditor";
import PasteImageUploader from "../../Storage/Components/PasteImageUploader";

const ModelTestQuestionForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
}) => {
  const optionsChoices = [
    {
      label: "A",
      value: "1",
    },
    {
      label: "B",
      value: "2",
    },
    {
      label: "C",
      value: "3",
    },
    {
      label: "D",
      value: "4",
    },
  ];

  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <HtmlEditor
          label="Question Text"
          name="questionText"
          placeholder="Enter Question text"
          onChange={onChange}
          error={errors.questionText}
          value={formData.questionText}
        // required
        />
        <PasteImageUploader
          label="Paste Question Image"
          name="questionImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.questionImage}
          error={errors.questionImage}
          upload
          uploadFolder="Simulator Uploads"
        />
        <Input
          label="Option A Text"
          type="text"
          name="optionA"
          value={formData.optionA}
          onChange={onChange}
          placeholder="Enter Option A text"
          error={errors.optionA}
        />
        <PasteImageUploader
          label="Paste Option A Image"
          name="optionAImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.optionAImage}
          error={errors.optionAImage}
          upload
          uploadFolder="Simulator Uploads"
        />
        <Input
          label="Option B Text"
          type="text"
          name="optionB"
          value={formData.optionB}
          onChange={onChange}
          placeholder="Enter Option B text"
          error={errors.optionB}
        />
        <PasteImageUploader
          label="Paste Option B Image"
          name="optionBImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.optionBImage}
          error={errors.optionBImage}
          upload
          uploadFolder="Simulator Uploads"
        />
        <Input
          label="Option C Text"
          type="text"
          name="optionC"
          value={formData.optionC}
          onChange={onChange}
          placeholder="Enter Option C text"
          error={errors.optionC}
        />
        <PasteImageUploader
          label="Paste Option C Image"
          name="optionCImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.optionCImage}
          error={errors.optionCImage}
          upload
          uploadFolder="Simulator Uploads"
        />
        <Input
          label="Option D Text"
          type="text"
          name="optionD"
          value={formData.optionD}
          onChange={onChange}
          placeholder="Enter Option D text"
          error={errors.optionD}
        />
        <PasteImageUploader
          label="Paste Option D Image"
          name="optionDImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.optionDImage}
          error={errors.optionDImage}
          upload
          uploadFolder="Simulator Uploads"
        />
        <Selector
          name="correctOptionIndex"
          label="Correct Option"
          value={formData?.correctOptionIndex}
          options={optionsChoices}
          isClearable={false}
          onChange={onChange}
          error={errors?.correctOptionIndex}
          required
        />
        <HtmlEditor
          label="Solution Text"
          name="solutionText"
          placeholder="Enter Solution text"
          onChange={onChange}
          error={errors.solutionText}
          value={formData.solutionText}
        // required
        />
        <PasteImageUploader
          label="Paste Solution Image"
          name="solutionImage"
          onChange={onChange} // Your existing onChange handler
          value={formData.solutionImage}
          error={errors.solutionImage}
          multiple
          upload
          uploadFolder="Simulator Uploads"
        />
        {/* <ImageSelector
          label="Select Solution Image"
          name="solutionImage"
          setModalOpen={setAnswerModalOpen}
          onChange={onChange}
          value={formData.solutionImage}
          placeholder="Click to select an image"
          error={errors.solutionImage}
        /> */}
      </form>
    </>
  );
};

export default ModelTestQuestionForm;
